function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33334 7.99992C1.33334 4.31992 4.32 1.33325 8 1.33325C11.68 1.33325 14.6667 4.31992 14.6667 7.99992C14.6667 11.6799 11.68 14.6666 8 14.6666C4.32 14.6666 1.33334 11.6799 1.33334 7.99992ZM3.33334 7.99989L6.66667 11.3332L12.6667 5.33323L11.7267 4.38656L6.66667 9.44656L4.27334 7.05989L3.33334 7.99989Z",
  fill: "#4ED25D"
});

var SvgAcPresenceTimeline = function SvgAcPresenceTimeline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAcPresenceTimeline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ac-presence-timeline.2fbb470a.svg";
export { ForwardRef as ReactComponent };